<template>
  <div class="inner_content">
    <div class="header">
      <!-- <div class="box flex" style="align-items=center">
        <el-input placeholder="请选择手机号或名称" size="small"></el-input>
        <el-button type="primary" size="small" @click="getLists"
          >筛选</el-button
        >
      </div> -->
      <el-form
        :inline="true"
        :model="params"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="支付方式：">
          <el-radio-group v-model="params.payType" size="small">
            <el-radio-button label="1">全部</el-radio-button>
            <el-radio-button label="2">核销</el-radio-button>
            <el-radio-button label="3">自用</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="用户名称：">
          <el-input
            v-model="params.name"
            placeholder="请输入用户名称或手机号"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="门店筛选：" v-if="!singleStatus">
          <el-select v-model="store_id" placeholder="请选择" size="small">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目筛选：" v-if="singleStatus">
          <el-select v-model="service_id" placeholder="请选择" size="small">
            <el-option
              v-for="item in serviceList"
              :key="item.value"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工筛选：" v-if="singleStatus">
          <el-select v-model="emp_id" placeholder="请选择" size="small">
            <el-option
              v-for="item in empList"
              :key="item.value"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getLists" size="small"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item class="options_item2" label="支付时间：">
          <el-radio-group
            v-model="params.time"
            size="small"
            @change="changeTime"
          >
            <el-radio-button label="0">全部</el-radio-button>
            <el-radio-button label="1">今天</el-radio-button>
            <el-radio-button label="2">昨天</el-radio-button>
            <el-radio-button label="7">最近7天</el-radio-button>
            <el-radio-button label="30">最近30天</el-radio-button>
            <el-radio-button label="m">本月</el-radio-button>
            <el-radio-button label="y">本年</el-radio-button>
            <el-radio-button label="z">自定义</el-radio-button>
            <!-- <el-radio-button v-for="item in paymentOptions" :key="item.value" :label="item.value">{{item.name}}</el-radio-button> -->
          </el-radio-group>
          <el-date-picker
            v-model="dateValue[0]"
            size="small"
            type="date"
            class="date_picker_box"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
            :disabled="params.time != 'z'"
          ></el-date-picker>
          <el-time-picker
            placeholder="时间"
            v-model="timeValue[0]"
            size="small"
            :disabled="params.time != 'z'"
            class="time_picker_box"
            format="HH:mm"
            value-format="HH:mm"
            arrow-control
          ></el-time-picker>
          <span style="margin-right:8px">至</span>
          <el-date-picker
            v-model="dateValue[1]"
            size="small"
            type="date"
            class="date_picker_box"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :disabled="params.time != 'z'"
          ></el-date-picker>
          <el-time-picker
            placeholder="时间"
            v-model="timeValue[1]"
            size="small"
            class="time_picker_box"
            :disabled="params.time != 'z'"
            format="HH:mm"
            value-format="HH:mm"
            arrow-control
          ></el-time-picker>
          <el-button
            size="small"
            type="primary"
            v-show="params.time == 'z'"
            @click="timeSearch()"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 汇总 -->
      <div class="show">
        <el-card class="box-card" shadow="hover">
          单数： <span>{{ total_num }}</span>
        </el-card>
        <el-card class="box-card" shadow="hover">
          累计积分： <span>{{ total_score }}</span>
        </el-card>
      </div>
    </div>
    <div class="bottom">
      <el-table
        :data="listData"
        size="small"
        :header-cell-style="setHeader"
        height="100%"
      >
        <el-table-column label="订单编号" prop="ordersn"></el-table-column>
        <el-table-column
          label="用户昵称"
          prop="user_info.username"
        ></el-table-column>
        <el-table-column
          label="手机号"
          prop="user_info.mobile"
        ></el-table-column>
        <el-table-column
          label="洗车服务名称"
          prop="service.name"
        ></el-table-column>
        <el-table-column
          label="洗车门店"
          prop="store_info.name"
        ></el-table-column>
        <el-table-column label="消耗积分" prop="score"></el-table-column>
        <el-table-column label="支付时间" prop="create_time"></el-table-column>
        <el-table-column label="使用情况" prop="isUser"></el-table-column>
        <el-table-column label="订单状态" prop="pay_status"></el-table-column>
        <el-table-column width="165px" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              slot="reference"
              @click="option(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
        :total="total_num"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  orderWash,
  indexRoomWash,
  orderDelWash,
  employeeListCar,
  indexWash
} from "@/api/carWash";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  inject: ["reload"],
  data() {
    return {
      singleStatus: false,
      store_id: "",
      emp_id: "",
      empList: [],
      service_id: "",
      serviceList: [],
      typeOptions: [], //项目类型
      inquireData: {
        radio1: ""
      },
      params: {
        time: "",
        payType: "1",
        name: ""
      },
      dateValue: [],
      timeValue: [],
      page: "1",
      total_num: 0,
      total_score: 0,
      listData: [],
      dialogFormVisible: false,
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      }
    };
  },
  mounted() {
    console.log("this.$route.query", this.$route);
    if (this.$route.query.room_id != 0) {
      this.singleStatus = true;
      this.store_id = this.$route.query.room_id;
      this.singleInit(this.store_id);
    }
    this.getLists();
    this.init();
  },
  methods: {
    init() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      indexRoomWash(data).then(res => {
        if (res.code == 200) {
          this.typeOptions = res.data.result;
        }
        console.log("列表", res);
      });
    },
    singleInit(room_id) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: room_id
      };
      employeeListCar(data).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.empList = res.data;
          indexWash(data).then(res => {
            if (res.code == 200) {
              this.serviceList = res.data.result;
            }
          });
        }
      });
    },
    // 格式化时间戳
    formatDate(t) {
      var time = new Date(t);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      h = h < 10 ? "0" + h : h;
      mm = mm < 10 ? "0" + mm : mm;
      return y + "-" + m + "-" + d + " " + h + ":" + mm;
    },
    formatTime(t, i) {
      //t:时间 i:格式化 1.截取到日期的00:00:00 2.截取到日期的23:59:59 3.截取到本月开始时间 4.截取到本年开始时间
      var time = this.formatDate(t);
      if (i == 1) {
        var rt = time.split(" ")[0] + " 00:00:00";
        return rt;
      } else if (i == 2) {
        var rt = time.split(" ")[0] + " 23:59:59";
        return rt;
      } else if (i == 3) {
        var rt = time.split("-")[0] + "-" + time.split("-")[1] + "-01 00:00:00";
        return rt;
      } else if (i == 4) {
        var rt = time.split("-")[0] + "-01-01 00:00:00";
        return rt;
      }
    },
    changeTime(val) {
      console.log(val);
      this.page = 1;
      if (val != "z") {
        this.getLists();
      }
    },
    // 时间筛选
    timeSearch() {
      if (!this.dateValue[0]) {
        this.$message("未选择开始时间");
      } else if (!this.dateValue[1]) {
        this.$message("未选择结束时间");
      } else if (
        new Date(this.dateValue[0]).getTime() >
        new Date(this.dateValue[1]).getTime()
      ) {
        this.$message("开始时间不能大于结束时间");
      } else {
        this.getLists();
      }
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    addSlice() {
      this.$router.push({
        path: `adSign`
      });
    },
    option(Oid) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: Oid
      };
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          orderDelWash(data).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.reload();
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch();
    },

    //
    getLists() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        payType: this.params.payType
      };
      //支付方式
      if (this.params.name != "") {
        data.name = this.params.name;
      }
      if (this.store_id != "") {
        data.store_id = this.store_id;
      }
      if (this.emp_id != "") {
        data.emp_id = this.emp_id;
      }
      if (this.service_id != "") {
        data.service_id = this.service_id;
      }

      // 時間篩選
      if (this.params.time != "0") {
        if (this.params.time == "1") {
          data.pay_start_time = this.formatTime(new Date(), 1);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "2") {
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24);
          data.pay_start_time = this.formatTime(start, 1);
          data.pay_end_time = this.formatTime(start, 2);
        }
        if (this.params.time == "7") {
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          data.pay_start_time = this.formatTime(start, 1);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "30") {
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          data.pay_start_time = this.formatTime(start, 1);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "m") {
          data.pay_start_time = this.formatTime(new Date(), 3);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "y") {
          data.pay_start_time = this.formatTime(new Date(), 4);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "z") {
          if (this.dateValue !== null && this.dateValue.length !== 0) {
            data.pay_start_time = this.timeValue[0]
              ? this.dateValue[0] + " " + this.timeValue[0]
              : this.dateValue[0] + " 00:00:00";
            data.pay_end_time = this.timeValue[1]
              ? this.dateValue[1] + " " + this.timeValue[1]
              : this.dateValue[1] + " 23:59:59";
          }
        }
        // 未支付状态参数传创建时间create_time_s/create_time_e 已支付传pay_start_time/pay_end_time
        if (this.params.pay_status == "1") {
          data.create_time_s = data.pay_start_time;
          data.create_time_e = data.pay_end_time;
          delete data.pay_start_time;
          delete data.pay_end_time;
        }
      }
      orderWash(data).then(res => {
        if (res.code == 200) {
          this.listData = res.data.result;
          this.listData.forEach(item => {
            item.pay_status = item.pay_status == 1 ? "已支付" : "未支付";
            item.isUser = item.is_use == 1 ? "已使用" : "未使用";
          });
          this.total_num = res.data.total_num;
          this.total_score = res.data.total_score;
        } else {
          this.$message.warning(res.msg);
        }
        console.log("列表", res);
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getLists();
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep.el-date-editor {
  width: 120px;
}
.inner_content {
  height: 100%;
  background: #fff;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  .header {
    padding-top: 20px;
    margin-bottom: 20px;
    .box {
      width: 330px;
      .title {
        min-width: 50px;
        text-align: right;
      }
      .fixedwidth {
        width: 180px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .show {
    width: 100%;
    display: flex;
    .box-card {
      flex: 1;
      padding-left: 30px;
      // text-align: center;
    }
  }
  .bottom {
    flex: 1;
    overflow-y: scroll;
  }
  .page {
    height: 50px;
    display: flex;
    align-items: center;
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
</style>
